import React, { useState } from 'react';
import PropTypes from 'prop-types';

import DialogHeader from '../../../DialogHeader/DialogHeader';
import ForYou from '../ForYou/ForYou';
import AccountNavSettings from '../AccountNavSettings/AccountNavSettings';
import AccountNavOrders from '../AccountNavOrders/AccountNavOrders';

import * as Styled from './AccountNavDialogV2.styled';

/**
 * Displays personalized content for an authenticated User
 */
const AccountNavDialogV2 = ({ isOpen, onRequestClose, withReactRouter }) => {
  const SECTIONS = [
    { label: 'For You', Component: () => <ForYou /> },
    {
      label: 'Orders',
      Component: () => (
        <AccountNavOrders
          onRequestClose={onRequestClose}
          withReactRouter={withReactRouter}
        />
      )
    },
    {
      label: 'Settings',
      Component: () => (
        <AccountNavSettings
          onRequestClose={onRequestClose}
          withReactRouter={withReactRouter}
        />
      )
    }
  ];

  const [sectionIndex, setSectionIndex] = useState(0);
  const Section = SECTIONS[sectionIndex].Component;

  return (
    <Styled.AccountNavDialogV2
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      hasBackdrop={false}
    >
      <DialogHeader
        withDivider={false}
        title={<Styled.AccountGreeting />}
        withCollapse
        rightComponent={
          <Styled.ButtonIcon
            variant="defaultLight"
            name="close"
            onClick={() => {
              setSectionIndex(0);
              onRequestClose();
            }}
            data-testid="AccountNavDialog__close-button"
            data-track-label="close"
            aria-label="close account nav"
          />
        }
        bottomComponent={
          <Styled.SelectSlide
            name="accountdrawer_slideoptions"
            onChange={(e) => setSectionIndex(Number(e.target.value))}
            selectedOption={sectionIndex}
          >
            {SECTIONS.map(({ label }, index) => (
              <Styled.SelectSlide.Option
                label={label}
                key={index}
                value={index}
              />
            ))}
          </Styled.SelectSlide>
        }
      />
      <Styled.DialogContainer>
        <Section />
      </Styled.DialogContainer>
    </Styled.AccountNavDialogV2>
  );
};

AccountNavDialogV2.propTypes = {
  /**
   * Parent component maintains the open/close state and passes down
   */
  isOpen: PropTypes.bool,
  /**
   * A function that is called when `AccountNavDialog` is requesting to close.
   */
  onRequestClose: PropTypes.func.isRequired,
  /**
   * `true` to render react router links
   *  when the component is rendered within a SPA such as Account
   *  otherwise render a normal anchor tag to navigate to the SPA
   */
  withReactRouter: PropTypes.bool
};

AccountNavDialogV2.defaultProps = { isOpen: false, withReactRouter: false };

export default AccountNavDialogV2;
